import deleteIconSvg from "static/images/delete-icon.svg";
import IconLinkButton from "components/common/controls/IconLinkButton";


interface Props {
  deleteClicked: () => void;
}

export default function PromineoDeleteActionColumnButton(props: Props) {
  const { deleteClicked } = props;

  const handleDeleteClick = () => {
    deleteClicked();
  };

  return (
    <>
      <IconLinkButton
        text="Delete"
        icon={deleteIconSvg}
        onClick={handleDeleteClick}
      />
    </>
  );
}
